module.exports = __webpack_public_path__ + "static/media/premium-supply.ef9988a7.jpg";